import React, { FunctionComponent } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { grayscaleGrayDark, whiteText } from "../../styles/theme";
import ChatbotIcon from "../Icons/ChatbotIcon";

interface ChatHeaderProps {
	onClose: () => void;
	onReset: () => void;
}

const ChatHeader: FunctionComponent<ChatHeaderProps> = ({
	onClose,
	onReset,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "12px 16px",
				backgroundColor: grayscaleGrayDark,
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						width: "32px",
						height: "32px",
						borderRadius: "50%",
						backgroundColor: "rgba(255, 255, 255, 0.18)",
					}}
				>
					<ChatbotIcon sx={{ width: 22, height: 22, color: whiteText }} />
				</Box>
				<Typography sx={{ color: whiteText, fontWeight: "bold" }}>
					Chatbot
				</Typography>
			</Box>
			<Box>
				<IconButton
					size="small"
					onClick={() => onReset()}
					title="Reset conversation"
				>
					<RestartAltIcon sx={{ color: whiteText }} fontSize="small" />
				</IconButton>
				<IconButton size="small" onClick={onClose}>
					<CloseIcon sx={{ color: whiteText }} fontSize="small" />
				</IconButton>
			</Box>
		</Box>
	);
};

export default ChatHeader;
